<template>
  <div id="app">
    <Header></Header>
    <router-view class="main" />
    <Footer></Footer>
  </div>
</template>

<script>
import './assets/css/reset.css';
import Header from '@/components/header';
import Footer from '@/components/footer';
export default {
  name: 'App',
  data(){
    return {

    }
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="less">
    body{
      background-color: #fefefe;
    }
    .wrap{
        width: 1400px;
        margin: 0 auto;
    }
    .w1280{
      width: 1280px;
      margin: 0 auto;
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
    .main{
      padding-top: 95px;
    }
    .content .sidebar .title{
      background: #d72538 !important;
      color: #fff !important;
    }
    .content .sidebar .list{
      background-color: #f2f2f2 !important;
      padding-bottom: 30px !important
    }
    .positionNav{
      height:80px;
      border-bottom:1px solid #ccc;
      padding:20px;
      box-sizing:border-box;
      text-align:right;
      line-height:40px;
      margin-bottom:20px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue